<template>
  <ProjectEdit></ProjectEdit>
</template>

<script>
import ProjectEdit from "@/components/ProjectEdit/index.vue";
export default {
  components: {
    ProjectEdit,
  },
};
</script>

<style></style>
